import React from 'react';
import clsx from 'clsx';

import ModifyButton from 'components/atoms/Button/ModifyButton';
import './index.scss';

const SpConfItem = ({
  title,
  modifyLinks = [],
  type = 'noTitle',
  items = [],
  changeModifyMode = () => {},
}) => {
  // 複数リンクの場合
  const PluralLinkNum = modifyLinks.length > 1;

  // 1段組
  const NoTitleItem = ({ items: noTitleItems }) => (
    <div className="NoTitleItem">
      {noTitleItems.map(item => (
        <div key={item} className="item-one-line">
          {item}
        </div>
      ))}
    </div>
  );
  // 複数リンクの場合
  const PluralNoTitleItem = ({ items: noTitleItems }) => (
    <div className="NoTitleItem">
      <div className="PluralNoTitleItem">
        {noTitleItems.map((item, idx) => (
          <div key={item} className="item-one-line">
            <div className="plural-modify-button-area">
              <div className="modify-button">
                <ModifyButton link={modifyLinks[idx]} onClick={changeModifyMode} />
              </div>
            </div>
            <div className="plural-item">
              {items[idx]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // 2段組
  const WithTitleItem = ({ items: withTitleItems }) => {
    return(
      <div className="WithTitleItem">
        {withTitleItems.map(item => {
          return(
            <div key={item.title}>
              <div key={item.title} className={clsx('item-one-line', { fullWidth: !!item.fullWidth })}>
                <div className="item-title">
                  {Array.isArray(item.title)
                    ? item.title.map(line => (
                      <span key={line} className="">
                        <span className="conf-title">
                          {line}
                          <br />
                        </span>
                      </span>
                    ))
                    : <>{item.title}</>}
                </div>
                <div className="item-content">
                  {Array.isArray(item.content)
                    ? item.content.map(line => {
                      return(
                        <>
                          <div key={line.workStyleKbn} className="content-syuugyouTime">
                            {line.startTime}
                            {' '}
                            -
                            {' '}
                            {line.endTime}
                            {' '}
                          </div>
                          <div>
                            <span className="content-restTime">
                              休憩
                              {' '}
                            </span>
                            {line.restTime}
                            {' '}
                            分
                            <br />
                          </div>
                        </>
                      );
                    })
                    : <>{item.content}</>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="SpConfItem"> 
      <div className="wrapper">
        <div className="title-wrapper">
          <div className="title">
            {title}
          </div>
          {!PluralLinkNum && (
            <div className="modify-button-area">
              {modifyLinks.map(link => (
                <div key={link} className="modify-button">
                  <ModifyButton link={link} onClick={changeModifyMode} />
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="items">
          {/* 単数リンク */}
          {!PluralLinkNum && (
            type === 'noTitle' ? <NoTitleItem items={items} /> : <WithTitleItem items={items} />
          )}
          {/* 複数リンク */}
          {PluralLinkNum && (
            type === 'noTitle' ? <PluralNoTitleItem items={items} /> : <WithTitleItem items={items} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SpConfItem;